import React from "react";
import DdlProfile from "../components/common/ddl-profile";
import { GetDataUserGroup } from '../components/utils/data-storage';
import { useLocation } from 'react-router-dom';

const Topbar = () => {
  const userGroup = GetDataUserGroup();
  const location = useLocation();

  const isAdminPage = location.pathname.startsWith("/admin");
  const useRoleInPage = isAdminPage ? "ADMIN" : "USER";

  const codeInPage = isAdminPage ? "AAR" : "UAR";

  return (
    <div className="topbar">
      <div className="topbar-actions">
        <DdlProfile useRoleInPage={useRoleInPage} codeInPage={codeInPage} />
      </div>
    </div>
  );
};

export default Topbar;